module.exports = __webpack_public_path__ + "06271c1f41c15a61664b4d0e81375658.svg";